import styled from "@emotion/styled";
import { Fragment, MouseEvent, PureComponent } from "react";

import { TicketsRoutes } from "constants/tickets/TicketsRoutes";
import { Column } from "constants/tickets/columns";
import { getColumns } from "helpers/tickets";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import { ITicket } from "interfaces/entities/ticket";
import { IAgent } from "store/entities/agents";
import { StackingContextLevel } from "styles/stacking-context-level";

import TicketField from "./TicketField";
import { TicketsListPreview } from "./TicketsListPreview";

interface IProps extends IWithBreakpointsProps {
  route: TicketsRoutes;
  ticket: ITicket;
  agents: IAgent[];
  columnTooltip: Column;
  previewEnabled: boolean;
  onMouseEnter(e: MouseEvent): void;
  onMouseLeave(e: MouseEvent): void;
  // @ts-expect-error TS(7010): 'onSpamModalRequest', which lacks return-type anno... Remove this comment to see the full error message
  onSpamModalRequest(type: "spam" | "unspam", selectedIds: string[]);
}

const PreviewWrapper = styled.div`
  position: absolute;
  z-index: ${StackingContextLevel.Preview};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

class TicketsListFields extends PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const {
      route,
      ticket,
      agents,
      columnTooltip,
      previewEnabled,
      isMobile,
      onSpamModalRequest,
      onMouseEnter,
      onMouseLeave,
    } = this.props;

    return getColumns(isMobile, route).map((column: Column) => {
      let decorator = null;
      if (previewEnabled && column === columnTooltip) {
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        decorator = (children: any) => (
          <PreviewWrapper>
            <TicketsListPreview ticket={ticket} agents={agents}>
              {children}
            </TicketsListPreview>
          </PreviewWrapper>
        );
      }

      return (
        <Fragment key={column}>
          <TicketField
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            column={column}
            ticket={ticket}
            route={route}
            agents={agents}
            // @ts-expect-error TS(2322): Type '((children: any) => Element) | null' is not ... Remove this comment to see the full error message
            decorator={decorator}
            onSpamModalRequest={onSpamModalRequest}
          />
        </Fragment>
      );
    });
  }
}

export default withBreakpoints(TicketsListFields);
